<template>
  <section class="slider-card">
    <div class="product-items">
      <div>
        <DefLabels :result="result.labels" />
      </div>
      <div>
        <DefFavourite v-if="isFavourite" :result="result" />
        <DefBuySecondary v-if="isAddToBasket" :result="result">
          <svg>
            <use xlink:href="#svg-plus"></use>
          </svg>
          <template #inBasket>
            <svg class="def-buy__icon"><use xlink:href="#svg-check"></use></svg>
          </template>
        </DefBuySecondary>
      </div>
    </div>

    <a :href="result.detailPage" class="slider-card__header" @click="eCommerceSend">
      <DefImg v-if="result.picture" :result="result.picture" />
      <GiaPhoto v-if="result.isGia" />
    </a>
    <a :href="result.detailPage" class="slider-card__footer" @click="eCommerceSend">
      <DefColorsSmall :result="result" />
      <span class="slider-card__name">{{ result.type }}</span>
      <span v-if="result.collection" class="slider-card__collection">
        {{ result.collection.name }}
      </span>
      <span v-if="result.price" class="slider-card__prices">
        <DefPrice v-if="result.price.printPrice">{{ result.price.printPrice }}</DefPrice>
        <DefPriceOld v-if="result.price.printPriceOld">{{
          result.price.printPriceOld
        }}</DefPriceOld>
      </span>
      <span v-if="result.price" class="slider-card__prices">
        <DefPriceEN>
          {{ result?.price?.printPriceEUR }}
        </DefPriceEN>
      </span>
    </a>
  </section>
</template>

<script>
import DefFavourite from '@components/Def/DefFavourite/DefFavourite.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import Analytics from '@/utils/Analytics/Analytics';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';
import DefBuySecondary from '@components/Def/DefBuy/DefBuySecondary.vue';

export default {
  name: 'SliderCard',
  components: {
    DefBuySecondary,
    DefLabels,
    DefPriceEN,
    DefPriceOld,
    DefPrice,
    DefColorsSmall,
    GiaPhoto,
    DefImg,
    DefFavourite,
  },
  props: {
    result: Object,
    isFavourite: {
      type: Boolean,
      default: true,
    },
    isAddToBasket: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    eCommerceSend() {
      Analytics.clickOnProduct(this.result);
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid var(--background-beige);
      animation: clippath 3s linear reverse;
      pointer-events: none;
    }
  }
  @keyframes clippath {
    0%,
    100% {
      clip-path: inset(0 0 95% 0);
    }
    25% {
      clip-path: inset(0 95% 0 0);
    }
    50% {
      clip-path: inset(95% 0 0 0);
    }
    75% {
      clip-path: inset(0 0 0 95%);
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 8px 12px;
    position: relative;
    @include point-lg {
      padding: 16px 16px 12px;
    }
  }
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    padding-bottom: 8px;
    @include point-lg {
      padding-bottom: 16px;
    }
  }
  &__name {
    text-align: center;
    margin-bottom: 8px;
    overflow: hidden;
    transition: 0.2s linear color;
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    max-height: 18px;
    text-transform: uppercase;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }
  &__collection {
    text-align: center;
    color: var(--color-dark-grey);
    margin-bottom: 16px;
    font-size: 12px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
  }
  .product-items {
    position: absolute;
    left: 12px;
    right: 12px;
    top: 8px;
    //bottom: 8px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    z-index: 2;
  }
  :deep(.def-price-old) {
    margin-left: 10px;
  }
  :deep(.def-colors-small) {
    margin-bottom: 12px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 8px;
    bottom: 8px;
    @include point-lg {
      bottom: 24px;
      right: 24px;
    }
  }
  :deep(.def-buy-secondary) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background-color: #f3f3f6;
    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
